import { action, makeObservable, observable } from "mobx";

export abstract class ReactiveItem<T extends { [key: string]: any }> {
  item: T;

  constructor(item: T, extraAnnotations: Record<string, any> = {}) {
    this.item = item;

    const annotations: Record<string, any> = {
      update: action,
      item: observable,
      ...extraAnnotations,
    };

    for (const key in item) {
      if (item.hasOwnProperty(key) && !this.excludedKeys().includes(key)) {
        (this as any)[key] = item[key];
        annotations[key] = observable;
      }
    }

    makeObservable(this, annotations);
  }

  /** Keys to skip during dynamic observable registration (handled via getters/setters instead) */
  protected excludedKeys(): string[] {
    return [];
  }

  update(obj: { [key: string]: any }) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        (this as any)[key] = obj[key];
        (this.item as any)[key] = obj[key];
      }
    }
  }
}
